import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = 'https//api.monkeybox.ai/api/menus';

// Thunks
export const fetchMenus = createAsyncThunk('menus/fetchAll', async () => {
  const res = await axios.get(API_BASE);
  return res.data;
});

export const createMenu = createAsyncThunk('menus/create', async (formData) => {
  const res = await axios.post(API_BASE, formData);
  return res.data;
});

export const updateMenu = createAsyncThunk('menus/update', async ({ id, formData }) => {
  const res = await axios.patch(`${API_BASE}/${id}`, formData);
  return res.data;
});

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    menus: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetMenuState: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMenus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.menus = action.payload;
      })
      .addCase(fetchMenus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      .addCase(createMenu.fulfilled, (state, action) => {
        state.menus.unshift(action.payload);
        state.success = true;
      })
      .addCase(createMenu.rejected, (state, action) => {
        state.error = action.error.message;
      })

      .addCase(updateMenu.fulfilled, (state, action) => {
        const index = state.menus.findIndex((m) => m.id === action.payload.id);
        if (index !== -1) state.menus[index] = action.payload;
        state.success = true;
      })
      .addCase(updateMenu.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export const { resetMenuState } = menuSlice.actions;
export default menuSlice.reducer;